//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import imageFit from "@/components/image/index";
import isNil from 'lodash/isNil';
import isEmpty from "lodash/isEmpty";
import { delFirstChar, formatPrice } from '@/utils/Help';
export default {
  name: 'two-column',
  type: 'component',
  options: {
    addGlobalClass: true,
  },
  props: {
    data: {
      type: Object
    },
    index: {
      type: Number
    },
    isGroupGoods:{
      type:Boolean,
      default:false
    },
    imageStyle: {
      type: String,
      default: "width: 370px; height: 370px;"
    },
    newCustomer:{ //是否是新人0：否、1：是）
      type: Number,
      default:0
    },
    floorAttribute:{ //floorAttribute 1：旧商品流 2：新商品流（卡片式）
      type: Number
    }
  },
  computed: {
    memberStyle() {
      const {firstPrice, secondPrice, thirdPrice} = this.data;
      let first = firstPrice && this.getMemberStyle(firstPrice);
      let second = secondPrice && this.getMemberStyle(secondPrice);
      let third = thirdPrice && this.getMemberStyle(thirdPrice);
      return {first, second, third};
    },
    lineThrough() {
      const {firstPrice, secondPrice, thirdPrice} = this.data;
      let first = firstPrice && this.getLineThrough(firstPrice);
      let second = secondPrice && this.getLineThrough(secondPrice);
      let third = thirdPrice && this.getLineThrough(thirdPrice);
      return {first, second, third};
    },
    cornorLabel() {
      const goodsLabel = this.data.goodsLabel;
      if (goodsLabel && goodsLabel.length > 0) {
        const {labelName, labelColor, labelBGColor, labelBorderColor} = goodsLabel[0];
        return {
          labelName,
          style: `background-color: ${labelBGColor}; color: ${labelColor}; border-color: ${labelBorderColor}`
        };
      } else {
        return null;
      }
    },
    activityLabels() {
      const activityLabel = this.data.activityLabel || [];
      // const activityLabel = Array(2).fill({labelName: '全球购', labelBGColor: 'red', labelColor: '#fff'});
      if (activityLabel && activityLabel.length > 0) {
        return activityLabel.map(item => {
          return {
            ...item,
            style: `background-color: ${item.labelBGColor || '#ff6f61'}; color: ${item.labelColor || '#fff'}; border-color: ${item.labelBorderColor || 'transparent'}`
          }
        });
      } else {
        return null;
      }
    },
    infoData() {
      let {activity, activityStatus, firstPrice = {},secondPrice = {}, thirdPrice = {}, goodsType, goodsName,groupStartTime,groupVolume,groupStatus,groupGiftId} = this.data || {};
      let isActivity = !isNil(activity);
      secondPrice = isNil(secondPrice) ? {} : secondPrice;
      firstPrice = isNil(firstPrice) ? {} : firstPrice;
      thirdPrice = isNil(thirdPrice) ? {} : thirdPrice;
      const priceInfo = !isEmpty(firstPrice.price) ? delFirstChar(firstPrice.price) : '';

      return {
        goodsName, goodsType, isActivity, activityStatus,groupStartTime,groupStatus,groupGiftId,
        firstPrice: !isNil(firstPrice.price) ? delFirstChar(firstPrice.price) : '',
        secondPrice: secondPrice.price || '',
        secondPriceName: secondPrice.memberFlag ? secondPrice.memberName : secondPrice.priceName ,
        secondStyle: `background-color: ${secondPrice.memberBgColor}; color: ${secondPrice.memberColor}; text-decoration: ${secondPrice.underlineFlag ? 'line-through' : 'none'}`,
        firstPriceName: this.newCustomer == 1 ? firstPrice.priceName : firstPrice.memberFlag ? firstPrice.memberName : '',
        firstStyle: `background-color: ${firstPrice.memberBgColor}; color: ${firstPrice.memberColor}; text-decoration: ${firstPrice.underlineFlag ? 'line-through' : 'none'}`,
        thirdPrice: thirdPrice.price || '',
        thirdPriceName:thirdPrice.priceName || '',
        activityPrice: isActivity ? activity.price : '',
        activityPriceName: isActivity ? activity.priceName : '',
        hasLine:thirdPrice.underlineFlag || '',
        groupVolume:groupVolume || 0,
        formatFirstPrice: !isEmpty(firstPrice.price) ? formatPrice(firstPrice.price) : []
      }
    }
  },
  methods: {
    onPress(goodsId, specialId, groupGiftId) {
      this.$emit("click", {goodsId, specialId, groupGiftId});
      // this.$router.app.navToGoods(this.index)
    },
    getMemberStyle(obj) {
      if (!obj) return;
      const {memberBgColor, memberColor, underlineFlag} = obj;
      return `background-color: ${memberBgColor}; color: ${memberColor};`;
    },
    getLineThrough(obj) {
      const {underlineFlag} = obj || {};
      return underlineFlag ? "text-decoration: line-through;" : undefined;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/twoColumn.vue